// Б.1.d: Кибер-псих — passive «Если на нём есть Модификация, получает +1/0/0».
//
// Реализация — императивная дельта в attachMod/detachMod (как принято в проекте):
//   - attachMod: после успешного push, если первый Мод (length === 1) — current.atk += 1.
//   - detachMod: после успешного splice, если последний Мод снят (length === 0) — current.atk -= 1.
// Этот модуль предоставляет только id и хелперы; интеграция — в modifications.js.
// TODO Б.2/Молчание: Молчание отменяет passive — current.atk должна откатиться даже если
// Моды остаются. В Б.1.d Молчания нет, оставляем простую логику.

export const CARD_ID = 'syn_kiberpsih';

export function kiberPsihOnModAttached(card) {
  if (card?.id !== CARD_ID) return;
  if ((card.modifications?.length ?? 0) === 1) {
    card.current.atk += 1;
  }
}

export function kiberPsihOnModDetached(card) {
  if (card?.id !== CARD_ID) return;
  if ((card.modifications?.length ?? 0) === 0) {
    card.current.atk -= 1;
  }
}
